import { toast } from 'react-toastify'

export const handleArrayBufferBackendError = (error: unknown) => {
  const responseData = (error as { response?: { data?: unknown } })?.response?.data
  if (responseData instanceof ArrayBuffer) {
    const decoder = new TextDecoder('utf-8')
    const errorText = decoder.decode(responseData)
    try {
      const parsed = JSON.parse(errorText)
      const details = parsed?.details
      toast(JSON.stringify(details), {
        type: 'error',
        position: 'top-center',
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          maxWidth: 400,
        },
      })
    } catch (e) {
      console.error('Failed to parse backend error message:', e)
    }
  }
}
